import React, { useState } from "react";
import { LanguageCode, LANGUAGES } from "../utils/translations";

interface Props {
  onLanguageChange: (code: LanguageCode) => void;
}

const LanguageSelector: React.FC<Props> = ({ onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLabel, setCurrentLabel] = useState("En");

  const handleSelect = (code: LanguageCode, label: string) => {
    setCurrentLabel(label);
    onLanguageChange(code);
    setIsOpen(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: "white",
          border: "1px solid #ddd",
          padding: "4px 4px",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          fontSize: "0.7rem",
          // FIXED DIMENSIONS: prevents Navbar shifting
          minWidth: "50px",
          width: "fit-content",
          height: "30px",
          justifyContent: "space-between",
          flexShrink: 0, // Prevents the button itself from being squashed
        }}
      >
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1, // Takes up all available space inside the 140px
            textAlign: "left",
          }}
        >
          🌐 {currentLabel}
        </span>
        <span style={{ fontSize: "0.4rem", opacity: 0.5, flexShrink: 0 }}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "115%",
            right: 0,
            backgroundColor: "white",
            border: "1px solid #eee",
            borderRadius: "6px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            zIndex: 1000,
            width: "90px", // Dropdown slightly wider than button
          }}
        >
          {LANGUAGES.map((lang) => (
            <div
              key={lang.code}
              onClick={() => handleSelect(lang.code, lang.label)}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                fontSize: "0.65rem",
                color: "#333",
                textAlign: "left",
                whiteSpace: "nowrap",
                borderBottom: lang.code === "en" ? "1px solid #f0f0f0" : "none",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f1f1f1")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
